var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 638,
    viewBox: "0 0 638 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M548.817 5.09668H89.1829C42.9416 5.09668 5.10522 42.9318 5.10522 89.1744V548.809C5.10522 595.05 42.9404 632.886 89.1829 632.886H548.817C595.058 632.886 632.895 595.051 632.895 548.809L632.9 89.1744C632.9 42.9331 595.064 5.09668 548.822 5.09668H548.817ZM151.774 508.643H99.4582V456.327H151.774V508.643ZM270.421 508.643H218.1V456.327H270.421V508.643ZM385.33 508.643H333.009V456.327H385.33V508.643ZM502.107 508.643H449.786V456.327H502.107V508.643ZM309.661 364.233L214.368 268.941L134.224 349.085L94.5872 309.448L214.363 189.672L309.651 284.959L479.481 115.129L519.118 154.766L309.661 364.233Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.24144c2679c2699d580b8abd26c95bdc.svg";
export { ForwardRef as ReactComponent };